module.exports = __webpack_public_path__ + "static/media/banner_s_02.037ed6ec.jpg";